import { render } from "./SignatureComponent.vue?vue&type=template&id=7f70534a&scoped=true"
import script from "./SignatureComponent.vue?vue&type=script&lang=js"
export * from "./SignatureComponent.vue?vue&type=script&lang=js"

import "./SignatureComponent.vue?vue&type=style&index=0&id=7f70534a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f70534a"]])

export default __exports__